export const NotificationType = {
    techOnTheWay: 'tech_on_the_way',
    paymentOrderRequired: 'pymt_order_request',
    aptmCancelled: 'aptm_cancelled_by_tech',
    appUpdateRequired: 'app_update_required',
    techArrived: 'tech_arrived',
    generic: 'generic',
};
